export default (data, currentService) => {
  const finalData = Object.keys(data).map(key => {
    const type = {
      value: key,
      name: data[key],
      isChecked: currentService.indexOf(key) > -1,
    };
    return type;
  });
  return finalData;
};
